export default {
  data: [],
  paginate: {},
};
